var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoI({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#2196F3",
    width: "15px",
    height: "15px",
    viewBox: "-0.813 0 3 3",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.054 0.001a0.28 0.28 0 0 1 0.301 0.294v-0.001a0.395 0.395 0 0 1 -0.394 0.376l-0.008 0h0a0.269 0.269 0 0 1 -0.296 -0.3l0 0.001A0.386 0.386 0 0 1 1.055 0.001h-0.001zM0.436 3c-0.159 0 -0.275 -0.098 -0.164 -0.528l0.182 -0.763c0.032 -0.122 0.037 -0.171 0 -0.171a1.2 1.2 0 0 0 -0.379 0.17l0.004 -0.003 -0.079 -0.132c0.386 -0.328 0.83 -0.52 1.02 -0.52 0.159 0 0.185 0.191 0.106 0.484l-0.208 0.803c-0.037 0.142 -0.021 0.191 0.016 0.191a0.819 0.819 0 0 0 0.358 -0.182l-0.001 0.001 0.09 0.122c-0.376 0.382 -0.785 0.529 -0.944 0.529z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoI);
export default __webpack_public_path__ + "static/media/InfoI.dac6761090d22e44b2034ccc4f5aaa48.svg";
export { ForwardRef as ReactComponent };